import React from 'react'

import * as S from './styles'
import { GlobalStyles } from './styles'

/**
 * @typedef {Object} DividerProps
 *
 * @property {'solid' | 'dashed' | 'dotted' | string} [variant]
 * @property {'xs' | 'sm' | 'md' | 'lg' | 'xl' | number} [size]
 * @property {'xs' | 'sm' | 'md' | 'lg' | 'xl' | number} [marginY]
 * @property {string | React.ReactNode} [label]
 * @property {'center' | 'left' | 'right'} [labelPosition]
 * @property {'horizontal' | 'vertical'} [orientation]
 */

/**
 * @param {DividerProps} props
 */
export default function Divider({
  variant,
  size = 'xs',
  marginY = 'xs',
  label,
  labelPosition,
  orientation
}) {
  return (
    <>
      <GlobalStyles />
      <S.Divider
        my={marginY}
        orientation={orientation}
        label={label}
        labelPosition={labelPosition}
        size={size}
        variant={variant}
      />
    </>
  )
}
